import { TeamAccessDTO } from '../team/team-access.dto';

export class ErrorTypeListDTO extends TeamAccessDTO {

    name: string;

    description: string;
    
}
